module.exports = fox._r("images/about-counters-img.jpg", __webpack_public_path__ + "images/about-counters-img.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/about-counters-img.jpg
// module id = 969
// module chunks = 4